import { motion } from "framer-motion";
import React from "react";
import useLayout from "src/hooks/useLayout";
import useWindowSize from "src/hooks/useWindowSize";

interface NavbarToggleProps {
	children?: any;
}

const NavbarToggle = ({ children }: NavbarToggleProps) => {
	const { layout, actions } = useLayout();
	const { isPhone, isTablet } = useWindowSize();
	const isDesktop = !(isPhone || isTablet);
	const variant: any = layout.navbar.variant || "default";
	if (!isDesktop) {
		return <></>;
	}
	return (
		<div className="absolute top-0 bottom-0 lg:hidden xl:flex items-center">
			<div
				onClick={() =>
					actions.setNavbar(
						variant === "default" ? "minimal" : "default"
					)
				}
				style={{ marginLeft: -12 }}
				className="bg-primary cursor-pointer w-6 h-6 rounded-sm text-white flex justify-center items-center transition-all hover:opacity-80"
			>
				<motion.div
					animate={variant}
					variants={{
						default: {
							rotate: 0,
						},
						minimal: {
							rotate: 180,
						},
					}}
				>
					<i className="fas h-0 fa-angle-left text-white"></i>
				</motion.div>
			</div>
		</div>
	);
};

export default NavbarToggle;
